








import { Component, Vue } from 'vue-property-decorator';
import { Hub } from 'aws-amplify';
import { Profile } from '@/api/model';

@Component
export default class App extends Vue {
  // Default layout value is just an empty div
  layout = 'div';

  beforeCreate() {
    Hub.listen('auth', (data) => {
      const { payload } = data;
      if (payload.event === 'signIn') {
        this.$store.dispatch('profile/getProfile');
        const redirect: any = this.$route.query.redirect || '/';
        this.$router.push(redirect);
      }
      if (payload.event === 'signOut') {
        this.$store.commit('profile/setProfile', {} as Profile);
        this.$router.push('/auth');
      }
    });
  }
}
